import { FormItemsGroup } from '@billy/design-system'

import { useInvoiceLinesColumns } from '../../../../../../hooks/useInvoiceLinesColumns'
import { CommonInvoiceLineFieldProps } from '../../../../types/commonInvoiceLineFieldProps'
import { InvoiceLineField } from './elements/InvoiceLineField'

export const InvoiceRowLineFields = ({ lineIndex }: CommonInvoiceLineFieldProps) => {
  const { columns, columnItemsTemplate } = useInvoiceLinesColumns()

  return (
    <FormItemsGroup itemsInRow={columnItemsTemplate.length} itemsTemplate={columnItemsTemplate}>
      {columns.map((column, index) => (
        <InvoiceLineField column={column} key={`${column}-${index}`} lineIndex={lineIndex} />
      ))}
    </FormItemsGroup>
  )
}
